import React, {PropsWithChildren} from 'react';

import {Container} from './styles';
import {PrintTemplateContainerProps} from './types';

export function PrintTemplateContainer({
	children,
	printRef,
}: PropsWithChildren<PrintTemplateContainerProps>) {
	return <Container ref={printRef}>{children}</Container>;
}
